export default __webpack_public_path__ + "static/media/IMG_028.8a481c25.jpg";